/**
 * UwDeckungDialog - record the Deckungsbestaetigung (P2 Slice 14 D5). From eingereicht the acceptance
 * is stamped implicitly.
 */

import { useEffect, useState } from 'react';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';
import type { UnderwritingResponse, UwDeckungBody } from '@brokly/shared';

const inputCls = 'w-full rounded-md border bg-card px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

const ERROR_TEXT: Record<string, string> = {
  antrag_status_invalid: 'Der Antrag ist nicht mehr in diesem Status',
};

export function UwDeckungDialog({
  open,
  onClose,
  facts,
  onSubmit,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  facts: UnderwritingResponse;
  onSubmit: (body: UwDeckungBody) => void;
  saving: boolean;
  error: string | null;
}) {
  const [bemerkung, setBemerkung] = useState('');
  useEffect(() => {
    if (open) setBemerkung('');
  }, [open]);

  const implizit = facts.antrag?.status === 'eingereicht';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Deckung bestaetigen"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={saving}>Zurueck</Button>
          <Button onClick={() => onSubmit({ bemerkung: bemerkung.trim() || null, communication_id: facts.carrier_reply?.communication_id ?? null })} disabled={saving} data-testid="uw-deckung-submit">
            Deckung bestaetigen
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3" data-testid="uw-deckung-dialog">
        {implizit && <p className="text-sm text-muted-foreground" data-testid="uw-deckung-implizit-note">Noch nicht angenommen - die Annahme wird implizit erfasst</p>}
        <label className="text-sm">
          Bemerkung
          <textarea value={bemerkung} onChange={(e) => setBemerkung(e.target.value)} rows={3} className={inputCls} data-testid="uw-deckung-bemerkung" />
        </label>
        {error && <p role="alert" className="text-sm text-status-danger" data-testid="uw-deckung-error">{ERROR_TEXT[error] ?? error}</p>}
      </div>
    </Dialog>
  );
}
